import { render } from "./BackLayoutHeader.vue?vue&type=template&id=36e0f538&scoped=true"
import script from "./BackLayoutHeader.vue?vue&type=script&lang=js"
export * from "./BackLayoutHeader.vue?vue&type=script&lang=js"

import "./BackLayoutHeader.vue?vue&type=style&index=0&id=36e0f538&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e0f538"]])

export default __exports__